#import "../fragments/wf-form-chat-fragment.graphql"

query GetWfFormsChat(
    $limit: Int!
    $after: String
    $archived: Boolean!
    $sort: FormSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
) {
    forms(
        first: $limit
        after: $after
        archived: $archived
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...WfFormChatFragment
            }
        }
    }
}
